import emptyImage from '../../assets/images/Common/empty-image.png'
import './EmptyData.scss'

export default function EmptyData() {
  return (
    <>
      <div className='lzfhunrhnl'><img src={emptyImage} alt="" className="" /></div>
    </>
  )
}